import { useForm } from "react-hook-form";
import { topicRuleService } from "../../service/TopicRule/topicRule.service";
import TopicRuleForm from "./_topicForm";
import { ITopicRuleCreateProps, ITopicRuleFormInput } from "./TopicRule.model";

const TopicRuleCreate = ({
  setTopicRuleDialog,
  loadTopicRules,
}: ITopicRuleCreateProps) => {
  const methods = useForm<ITopicRuleFormInput>({
    defaultValues: {
      topic: 0,
      year_of_experience: 0,
      high_no_of_question: 0,
      medium_no_of_question: 0,
      low_no_of_question: 0,
    },
  });

  const { setError } = methods;

  const onSubmit = async (data: ITopicRuleFormInput) => {
    try {
      await topicRuleService.create(data);
      loadTopicRules();
      setTopicRuleDialog(false);
    } catch (err: any) {
      if (err.response?.data) {
        const errors = err.response.data;

        Object.keys(errors).forEach((key) => {
          setError(key as keyof ITopicRuleFormInput, {
            type: "server",
            message: Array.isArray(errors[key]) ? errors[key][0] : errors[key],
          });
        });
      }
    }
  };

  return (
    <TopicRuleForm methods={methods} onSubmit={onSubmit} isEdit={false} />
  );
};

export default TopicRuleCreate;
